import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


export interface Step {
  label: string;
  completed: boolean;
  number: number;
  translationKey?: string;
}

@Component({
  selector: 'app-horizontal-stepper',
  templateUrl: './horizontal-stepper.component.html',
  styleUrls: ['./horizontal-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HorizontalStepperComponent {

  @Input() steps: ReadonlyArray<Step> = [];
  @Input() currentStep: number = 1;

  isStepCompleted(step: Step): boolean {
    return step.completed;
  }

  isStepActive(step: Step): boolean {
    return step.number === this.currentStep && !step.completed;
  }

  getStepAriaLabel(step: Step, index: number): string {
    return `${step.label}. ${index + 1}/${this.steps.length}`;
  }

  trackByStepNumber(_index: number, step: Step): number {
    return step.number;
  }
}
